import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 14px 24px;
  min-height: 100vh;
`;

export const Flex = styled.div`
  display: flex;
  margin-top: 14px;
  gap: 16px;
  width: 100%;
`;

export const FundsList = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 10px;
  margin-top: 16px;
  padding-bottom: 5px;
`;

export const FundsItem = styled.div`
  width: calc(25% - 7px);
  min-width: calc(25% - 7px);
`;

export const EllipsisText = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  width: 400px;
  white-space: nowrap;
  font-weight: 700;
`;

export const ScaledIconWrapper = styled.span`
  display: inline-block;
  transform: scale(1.3);
`;

export const FlexHeader = styled.div`
  display: flex;
  justify-content: space-between;
  .no-shrink {
    flex-shrink: 0;
    white-space: nowrap;
  }
`;
